import { Storage } from 'aws-amplify';
import * as api from '../_api';

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const version = await api.read();
    commit('setVersion', version);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};
